import { createAction, props } from '@ngrx/store';
import { getActionName } from '@app/core/state/state-helpers';
import { DoaAuthorisationTableRequest } from '@app/delegation-of-authority/models/requests/doa-authorisation-table-request';

export const doaActionPrefix = '[DOA]';

export const loadDoaAuthorisationTable = (<T>() =>
  createAction(
    getActionName('Load DOA Authorisation Table', doaActionPrefix),
    props<{
      request: DoaAuthorisationTableRequest<T>;
    }>(),
  ))();

export const loadDoaAuthorisationTableSuccess = createAction(
  getActionName('Load DOA Authorisation Table Success', doaActionPrefix),
);

export const loadDoaAuthorisationTableFailure = createAction(
  getActionName('Load DOA Authorisation Table Failure', doaActionPrefix),
);
